import { Component } from '@angular/core';
import { Location } from '@angular/common';

import { StatisticService } from '../../../services/statistic.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.html',
  providers: [StatisticService]
})
export class DashboardComponent {
  constructor(public location: Location) {
  }

  getStyleLink(path: string) {
    return this.location.path().startsWith(path);
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/dashboard/dashboard.component.ts